module.exports = __webpack_public_path__ + "assets/img/header-small.d6046608.jpg";